<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/master-data">Master Data</a><span>/ Repair Location</span>
</div>

<form [formGroup]="filterFormGroup" class="list-repair-location-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Repair Location</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-repair-location-search
        class="search-bar"
        [repairLocationSearchTextForm]="filterFormGroup.controls.repairLocationSearchTextForm">
      </app-repair-location-search>
    </div>
  </div>
  <app-repair-location-filters [filterFormGroup]="filterFormGroup"></app-repair-location-filters>
  <app-repair-location-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-repair-location-grid>
</form>
